// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconAddressBook } from '@tabler/icons-react';

const mesdocuments = {
    id: 'mes-documents',
    title: <FormattedMessage id="mes-documents" />,
    icon: IconAddressBook,
    type: 'group',
    url: '/ui/mes-documents'
};

export default mesdocuments;
